<script>
import PedalKnob from '../PedalKnob.vue';
import CcBadge from '../CcBadge.vue';

export default {
  components: { PedalKnob, CcBadge },
  props: {
    effect: {
      type: Object,
      required: true
    }
  }
}
</script>
<template>
  <div class="pedal-knobs">
    <CcBadge :effect="effect" param="min">
      <PedalKnob
        label="Min"
        tip="Minimum value."
        :value="effect.min"
        @update:value="v => effect.min = v"
        />
    </CcBadge>
    <CcBadge :effect="effect" param="max">
      <PedalKnob
        label="Max"
        tip="Maximum value."
        :value="effect.max"
        @update:value="v => effect.max = v"
        />
    </CcBadge>
    <CcBadge :effect="effect" param="gradient">
      <PedalKnob
        label="Grad"
        tip="Higher values create a gentler, more gradual curve. Lower values create a sharper, more abrupt transition."
        mode="bipolar"
        :value="effect.gradient ?? 0"
        @update:value="v => effect.gradient = v"
        />
    </CcBadge>
    <CcBadge :effect="effect" param="balance">
      <PedalKnob
        label="Bal"
        tip="Controls the symmetry of the curve's S-shape. Positive values shift the curve, spending more time near the maximum."
        mode="bipolar"
        :value="effect.balance ?? 0"
        @update:value="v => effect.balance = v"
        />
    </CcBadge>
    <CcBadge :effect="effect" param="skew">
      <PedalKnob
        label="Skew"
        tip="Position of the peak within the cycle. Negative values mean a fast attack and slow release; positive values mean a slow attack and fast release."
        mode="bipolar"
        :value="effect.skew ?? 0"
        @update:value="v => effect.skew = v"
        />
    </CcBadge>
  </div>
</template>
